<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>邮箱管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions" style="position: static;float: left">
        <el-select :value="queryType" @change="setQueryType" placeholder="请选择">
          <el-option
              v-for="item in queryTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-input
            placeholder="请选择ID或登录邮箱搜索"
            clearable
            v-model="queryData.queryValue"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>

        <el-select :value="queryType2" @change="setQueryType2" placeholder="请选择分组">
          <el-option
              v-for="item in queryTypeList2"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-select :value="queryType3" @change="setQueryType3" placeholder="请选择分组类型">
          <el-option
              v-for="item in queryTypeList3"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-button
            type="primary"
            @click="handleSearch"
        >搜索
        </el-button>
        <el-button
            type=""
            @click="handleSearchReset"
        >重置
        </el-button>

      </div>
      <div class="preview-opration" style="float: right;right: 0px; white-space:nowrap">
        <el-button style="margin-right: 35px" icon="" type="primary" @click="batchEdit">批量修改组
        </el-button>
      </div>

      <el-table :data="dataList" ref="multipleTable" @selection-change="handleSelectionChangeFun">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="用户ID"></el-table-column>
        <el-table-column prop="email" label="登录账户"/>
        <el-table-column prop="content" label="绑定邮箱">
          <template slot-scope="scope">
            {{ scope.row.emailGroupId === 1 || scope.row.emailGroupId === null ? "" : getGroup(scope.row.emailGroupId).email }}
          </template>
        </el-table-column>
        <el-table-column prop="emailGroupId" label="用户分组">
          <template slot-scope="scope">
            {{ scope.row.emailGroupId === 1 || scope.row.emailGroupId === null ? "普通用户" : getGroup(scope.row.emailGroupId).label }}
          </template>
        </el-table-column>
        <el-table-column prop="emailGroupId" label="分组类型">
          <template slot-scope="scope">
            {{ scope.row.emailGroupId === 1 || scope.row.emailGroupId === null ? "普通用户" : "股东用户" }}
          </template>
        </el-table-column>
        <el-table-column label="更新时间">
          <template slot-scope="scope">
            {{ scope.row.updateTime | moment }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!--            <el-button type="" v-show="scope.row.type!=0" icon="el-icon-show" @click="seeTaskData(scope.row)">查看-->
            <!--            </el-button>-->
            <el-button type="primary" icon="el-icon-edit"
                       @click="handleEditRow(scope.row)">修改
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="queryData.pageSize"
                     :current-page.sync="queryCondition.pageNo" @current-change="changePage"/>
    </el-card>

    <el-dialog title="批量修改分组" :visible.sync="dialogVisible" width="30%" @close="clearEdit"
               :close-on-click-modal="false">
      <div>
        <div style="margin-top: 20px">
            <span style="padding-right: 50px">
            <i style="color: #f56c6c;margin-right: 1px;">&nbsp;</i>
            分组</span>
          <el-select :value="queryTypeUpdate" @change="setQueryTypeUpdate" placeholder="请选择分组">
            <el-option
                v-for="item in queryTypeList2"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="editFun">确 定</el-button>
            </span>
    </el-dialog>

    <el-dialog title="修改绑定邮箱" :visible.sync="dialogVisible2" width="30%" @close="clearEdit2"
               :close-on-click-modal="false">
      <div>
        <div style="margin-top: 20px">
          <span style="padding-right: 20px;">
            登录账户&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <el-input maxlength="30" style="width: 70%" size="small"  v-model="editData.email" disabled></el-input>
        </div>
        <div style="margin-top: 20px">
          <span style="padding-right: 20px;">
            已绑定邮箱</span>
          <el-input maxlength="30" style="width: 70%" size="small" v-model="editData.bindEmail" disabled></el-input>
        </div>
        <div style="margin-top: 20px">
            <span style="padding-right: 20px">
            分组&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <el-select :value="queryTypeUpdate2" @change="setQueryTypeUpdate2" placeholder="请选择分组">
            <el-option
                v-for="item in queryTypeList2"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="editFun2">确 定</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>
import api from './api'

export default {
  name: 'emailUser',
  data() {
    return {
      dialogVisible: false,
      dialogVisible2: false,
      editData:{},
      total: 0,
      account: '',
      dataList: [],
      queryData: {
        pageNum: 1,
        pageSize: 15,
        queryValue: "",
        queryType: "",
        groupId: "",
        groupType: ""
      },
      queryCondition: {
        pageNo: 1
      },
      queryType: "",
      queryTypeList: [
        {
          value: "1",
          label: "ID"
        },
        {
          value: "2",
          label: "登录账户"
        }
      ]
      ,
      queryType2: "",
      queryTypeList2: []
      ,
      queryType3: "",
      queryTypeList3: [
        {
          value: "0",
          label: "普通用户"
        },
        {
          value: "1",
          label: "股东用户"
        }
      ],
      queryTypeUpdate: "",
      queryTypeUpdate2: "",
      handleSelectionChange: []
    };
  },
  computed: {},
  methods: {
    getList() {
      this.trimQuery();
      api.getUsers(this.queryData).then(res => {
        console.log(res)
        this.dataList = res.data.records;
        this.total = res.data.total;
      })
    },
    handleSearch() {
      this.getList();
    },
    handleSearchReset() {
      this.queryType = "";
      this.queryType2 = "";
      this.queryType3 = "";
      this.queryData.queryValue = "";
      this.queryData.queryType = "";
      this.queryData.groupId = "";
      this.queryData.groupType = "";
    },
    setQueryType(select) {
      this.queryType = select;
      this.queryData.queryType = select;

    },
    setQueryType2(select) {
      this.queryType2 = select;
      this.queryData.groupId = select;
    },
    setQueryType3(select) {
      this.queryType3 = select;
      this.queryData.groupType = select;
    },
    setQueryTypeUpdate(select) {
      this.queryTypeUpdate = select;
    },
    setQueryTypeUpdate2(select) {
      this.queryTypeUpdate2 = select;
    },
    changePage(val) {
      this.queryData.pageNum = val;
      this.getList();
    },
    groupList() {
      api.groupList({page: 1, size: 100, search: ""}).then(res => {
        this.queryTypeList2 = [];
        res.data.forEach(item => {
          this.queryTypeList2.push({
            value: item.id,
            label: item.name,
            email: item.email
          });
        })
      })
    },
    handleSelectionChangeFun(val) {
      this.multipleSelection = val;
      console.log(val)
    },
    batchEdit() {
      if (!this.multipleSelection) {
        this.$message.error("请选择用户编辑");
        return;
      }
      this.dialogVisible = true;
    },
    editFun() {
      var ids = [];
      this.multipleSelection.forEach(item => {
        ids.push(item.id);
      })
      api.edit({userIds: ids.join(), groupId: this.queryTypeUpdate}).then(res => {
        if (res.code === 0) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
        } else {
          this.$message.error("修改失败");
        }
      })
    },
    editFun2() {
      if(this.queryTypeUpdate2===this.editData.emailGroupId){
        this.$message.success("修改成功");
        this.dialogVisible2 = false;
      }
      api.edit({userIds: this.editData.id, groupId: this.queryTypeUpdate2}).then(res => {
        if (res.code === 0) {
          this.$message.success("修改成功");
          this.dialogVisible2 = false;
        } else {
          this.$message.error("修改失败,请重试");
        }
      })
    },
    clearEdit() {
      this.queryTypeUpdate = "";
      this.getList();
    },
    clearEdit2(){
      this.queryTypeUpdate = "";
      this.editData={};
      this.getList();
    },
    handleEdit(rowData) {
      this.queryTypeUpdate2=rowData.emailGroupId;
      this.editData=rowData;
      this.dialogVisible2 = true;
      this.editData.bindEmail=rowData.emailGroupId === 1 || rowData.emailGroupId === null ? "" : this.getGroup(rowData.emailGroupId).email;
    },
    handleEditRow(rowData) {
      this.queryTypeUpdate2=rowData.emailGroupId;
      this.editData=rowData;
      this.editDataRow=rowData;
      this.editData.bindEmail=rowData.emailGroupId === 1 || rowData.emailGroupId === null ? "" : this.getGroup(rowData.emailGroupId).email;
      this.dialogVisible2 = true;
      console.log(this.editDataRow)
    },
    getGroup(id){
      console.log(id)
      console.log(this.queryTypeList2)
      let res={};
      this.queryTypeList2.forEach(item=> {
        console.log(item.value==id)
        if (item.value==id){
          res=item;
        }
      })
      return res;
    },
    trimQuery() {
      this.queryData.queryValue= this.queryData.queryValue.replace(/(^\s*)|(\s*$)/g, '')
    }

  },
  created() {
    this.groupList();
    this.getList();
  }
};
</script>

<style lang="less" scoped>
</style>
